import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { ClientFooter } from '../../legacy/js/components/HeaderFooter/ClientFooter';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.ClientFooter = ClientFooter;
